export default __webpack_public_path__ + "static/media/homeicondark.7d72c6db.svg";